<template>
  <!-- <v-card> -->
  <!-- <card-title-bar icon="mdi-truck-outline" text="配送方法"></card-title-bar> -->

  <div>
    <v-radio-group v-model="delivery" :mandatory="false">
      <!-- ヤマト運輸配送 -->
      <v-radio
        label="ヤマト運輸配送"
        :value="deliveryYoupack"
        :disabled="existSpPrice"
      ></v-radio>
      <ul class="ml-5 py-0 text-caption grey--text">
        <li v-if="existSpPrice" class="red--text">
          特別価格商品はヤマト運輸配送に対応していません
        </li>
        <li>商品サイズと数量に基づき送料が決定されます</li>
        <li>お届け先の住所を入力して送料計算ボタンを押してください</li>
      </ul>
      <v-row no-gutters class="mt-3">
        <!-- 配送先 -->
        <v-col cols="6" sm="2">
          <v-text-field
            dense
            label="郵便番号"
            ref="zip"
            v-model="zip"
            :rules="[rules.required, rules.zip]"
            maxlength="8"
            @input="fetchAddress"
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="2">
          <v-select
            dense
            label="都道府県"
            ref="prefecture"
            :items="prefectures"
            return-object
            item-value="id"
            item-text="name"
            v-model="prefecture"
            :rules="[rules.required]"
            style="display: none"
          ></v-select>
          <v-text-field
            dense
            disabled
            placeholder="郵便番号入力で表示"
            label="都道府県"
            v-model="prefecture.name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="8">
          <v-text-field
            dense
            label="住所"
            :rules="[rules.required, rules.address]"
            v-model="address"
            ref="address"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            label="氏名"
            ref="name"
            v-model="name"
            :rules="[rules.required, rules.name]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            label="電話番号"
            ref="tel"
            v-model="tel"
            :rules="[rules.required, rules.tel]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters justify="space-between">
        <!-- アドレス帳ボタン -->
        <v-col v-if="showAddressListBtn" align="start">
          <v-btn
            text
            color="primary"
            class="text-caption"
            :loading="addressLoading"
            :disabled="delivery == deliveryDirect"
            @click.stop="openAddressList"
            >アドレス帳</v-btn
          >
          <address-lists
            ref="addressLists"
            :lists="addressLists"
            :confirm-action="reflectAddress"
          ></address-lists>
        </v-col>
        <!-- 送料計算ボタン -->
        <v-col align="end">
          <v-btn
            rounded
            color="primary"
            :loading="postageLoading"
            :disabled="
              area_id == 0 || delivery == deliveryDirect || postageConfirm
            "
            @click="calcPostage"
            >送料計算</v-btn
          >
        </v-col>
      </v-row>

      <!-- グループ配送 -->
      <template v-if="existGroup">
        <v-radio
          label="グループ / 直接配達"
          class="mb-0"
          :value="deliveryDirect"
        ></v-radio>
        <ul class="ml-5 py-0 text-caption grey--text">
          <li>ご契約の場所へ直接お届けいたします</li>
        </ul>
        <!-- グループ情報 -->
        <v-row no-gutters v-if="group" class="pa-0 pr-3 text-caption">
          <v-col cols="12" align="start"
            >〒{{ group.zip }} {{ group.address }}</v-col
          >
          <v-col cols="8" sm="3">{{ group.name }} 様</v-col>
          <v-col cols="4" sm="3">{{ group.tel }}</v-col>
        </v-row>
        <!-- グループ情報取得中 -->
        <v-container v-else class="ml-4 pa-0 pr-3 text-caption">
          <div class="pl-7">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-container>
      </template>
    </v-radio-group>
    <!-- 送料小計 -->
    <v-divider></v-divider>
    <v-container class="pa-0 ma-0" v-if="delivery == deliveryYoupack">
      <v-row no-gutters class="px-3">
        <template v-for="(packing, index) in packings">
          <v-col cols="12" sm="6" class="text-caption" :key="`name${index}`">
            {{ packing.packing_name }} (サイズ{{ packing.youpack_size
            }}<span class="red--text">{{ packing.overweight ? '*' : '' }}</span
            >)
          </v-col>
          <v-col
            align="end"
            cols="8"
            sm="3"
            class="text-caption"
            :key="`qty${index}`"
          >
            数量:{{ packing.qty }}
          </v-col>
          <v-col
            align="end"
            cols="4"
            sm="3"
            class="text-caption"
            :key="`amount${index}`"
          >
            {{ packing.amount | toPriceFormat }}
          </v-col>
          <v-col
            v-if="packing.overweight"
            cols="12"
            class="text-caption red--text"
            :key="`overwight${index}`"
          >
            *重量ヤマト運輸対象です
          </v-col>
        </template>
      </v-row>
    </v-container>
    <div align="end" class="mt-3">
      <!-- 小計金額 -->
      <span class="mx-3" v-if="showPostageSubTotal"
        >送料小計: {{ postageSubTotal | toPriceFormat }}</span
      >
      <span class="mx-3" v-else>送料小計: (未算出です)</span>
    </div>
  </div>
  <!-- </v-card> -->
</template>

<script>
// import CardTitleBar from './parts/CardTitleBar'
import AddressLists from './AddressLists.vue';
import {
  prefectures,
  getAreaId,
  findPrefCodeByName,
} from '../../assets/prefectures.js';
import axiosOthers from '../../assets/axios-others.js';
import axiosJsonpAdapter from 'axios-jsonp';

const ZIPCODE_API_URL = 'https://zipcloud.ibsnet.co.jp/api/search';

export default {
  name: 'DeliverySelect',
  components: {
    // CardTitleBar,
    AddressLists,
  },
  props: {
    deliveryDirect: Number,
    deliveryYoupack: Number,
    existSpPrice: Boolean,
    existGroup: Boolean,
    group: Object,
    showAddressListBtn: Boolean,
    loadAddressListAction: Function,
    addressLists: Array,
    calcPostageAction: Function,
    packings: Array,
    postageSubTotal: Number,
  },
  data: () => ({
    delivery: 0,
    // 都道府県一覧
    prefectures,
    // ヤマト運輸配送先
    name: '',
    zip: '',
    prefecture: { id: 0, name: '' },
    address: '',
    tel: '',
    area_id: 0,
    // アドレス帳ロード
    addressLoading: false,
    // 送料ロード
    postageLoading: false,
    // 送料確定
    postageConfirm: false,
    // 入力ルール
    rules: {
      required: value => !!value || '必須入力です',
      name: v => v.length <= 30 || '30文字以内で入力してください',
      address: v => v.length <= 50 || '50文字以内で入力してください',
      zip: value => {
        const pattern = /^\d{3}-?\d{4}$/;
        return pattern.test(value) || '無効な郵便番号です';
      },
      tel: value => {
        const target = value ? value.replace(/-/g, '') : '';
        const pattern = /^\d{7,13}$/;
        return pattern.test(target) || '無効な電話番号です';
      },
    },
  }),
  computed: {
    // 顧客グループ名
    groupName() {
      return this.group ? this.group.name : '';
    },
    // 顧客グループ郵便番号
    groupZip() {
      return this.group ? this.group.zip : '';
    },
    // 顧客グループ住所
    groupAddress() {
      return this.group ? this.group.address : '';
    },
    // 顧客グループTEL
    groupTel() {
      return this.group ? this.group.tel : '';
    },
    showPostageSubTotal() {
      return this.delivery == this.deliveryDirect || this.postageConfirm;
    },
    // 入力情報
    info() {
      return {
        delivery: this.delivery,
        destination_name:
          this.delivery == this.deliveryDirect ? this.groupName : this.name,
        destination_zip:
          this.delivery == this.deliveryDirect ? this.groupZip : this.zip,
        destination_address:
          this.delivery == this.deliveryDirect
            ? this.groupAddress
            : this.prefecture.name + this.address,
        destination_tel:
          this.delivery == this.deliveryDirect ? this.groupTel : this.tel,
        area_id: this.delivery == this.deliveryDirect ? 0 : this.area_id,
        postageConfirm: this.postageConfirm,
        showPostageSubTotal: this.showPostageSubTotal,
        entered: this.entered,
      };
    },
    // 入力済判定
    entered() {
      if (this.delivery == this.deliveryYoupack) {
        // 配送先情報が不足
        if (
          !this.name ||
          !this.zip ||
          !this.prefecture ||
          !this.address ||
          !this.tel
        )
          return false;
        // 送料確定前
        if (!this.postageConfirm) return false;
      } else if (this.delivery == this.deliveryDirect) {
        // 配送先グループ情報取得前
        if (!this.groupName || this.groupName == '') return false;
      }
      return true;
    },
  },
  methods: {
    // 住所取得
    async fetchAddress() {
      if (this.$refs.zip.validate()) {
        // 住所apiを叩く
        await axiosOthers
          .get(ZIPCODE_API_URL, {
            adapter: axiosJsonpAdapter,
            params: {
              zipcode: this.zip,
            },
          })
          .then(({ data }) => {
            if (data.results) {
              // 返却されたデータを挿入する
              this.prefecture = {
                id: Number(data.results[0].prefcode),
                name: data.results[0].address1,
              };
              this.address =
                data.results[0].address2 + data.results[0].address3;
              this.$refs.address.focus();
            } else {
              this.prefecture = { id: 0, name: '' };
              this.address = '';
              this.$refs.zip.focus();
            }
          })
          .catch(() => {
            this.$refs.zip.focus();
          });
      }
    },
    // アドレス帳を開く
    async openAddressList() {
      this.addressLoading = true;
      await this.loadAddressListAction();
      this.addressLoading = false;

      this.$refs.addressLists.dialog = true;
    },
    // 選択された送付先住所を反映
    reflectAddress(item) {
      const address = item.address
        .replace(/^(.{2}[都道府県]|.{3}県)(.+)/, '$1 $2')
        .split(' ');
      const [prefecture, ...others] = address;
      this.name = item.name;
      this.zip = item.zip;
      this.prefecture = {
        id: findPrefCodeByName(prefecture),
        name: prefecture,
      };
      this.address = others.join(' ');
      this.tel = item.tel;
    },
    // 送料計算
    async calcPostage() {
      if (this.delivery == this.deliveryDirect) return;
      if (!this.$refs.zip.validate()) return;
      if (this.postageConfirm) return;

      this.postageLoading = true;

      await this.calcPostageAction(this.area_id);

      this.postageLoading = false;
      this.postageConfirm = true;
    },
    // 送料確定を解除
    resetPostageConfirm() {
      this.postageConfirm = false;
    },
    // 入力検証
    validated() {
      if (this.delivery == this.deliveryYoupack) {
        // ヤマト運輸配送選択時の入力チェック
        if (!this.$refs.name.validate()) {
          this.$refs.name.focus();
          return false;
        }
        if (!this.$refs.zip.validate()) {
          this.$refs.zip.focus();
          return false;
        }
        if (!this.$refs.prefecture.validate()) {
          this.$refs.prefecture.focus();
          return false;
        }
        if (!this.$refs.address.validate()) {
          this.$refs.address.focus();
          return false;
        }
        if (!this.$refs.tel.validate()) {
          this.$refs.tel.focus();
          return false;
        }
      }
      return true;
    },
  },
  created() {
    this.delivery = this.existSpPrice
      ? this.deliveryDirect
      : this.deliveryYoupack;
  },
  watch: {
    prefecture: function() {
      if (this.prefecture) {
        // 都道府県からエリアID設定
        this.area_id = getAreaId(this.prefecture.id);
      }
      this.postageConfirm = false;
    },
    delivery: function() {
      if (this.delivery == this.deliveryDirect) {
        this.postageConfirm = false;
      }
    },
    postageConfirm: function() {
      if (!this.postageConfirm) {
        // 送料確定が解錠されたことを通知する
        this.$emit('postage-confirm-canceled');
      }
    },
    info: function() {
      this.$emit('info-changed', this.info);
    },
  },
};
</script>
